<style lang="scss" scoped>
.dragging {
  border: 2px solid #2b736b;
  border-radius: 5px;
  background-color: #d8ffed;
  .v-card {
    background-color: #d8ffed;
  }
}
</style>
<template>
  <v-row>
    <v-col cols="12">
      <input
        type="file"
        ref="file"
        @change="handleUploadFiles"
        v-show="false"
        accept="application/pdf, image/png, image/jpeg, text/*, .docx, .pptx, .xlsx"
        multiple
      />
      <v-card outlined>
        <v-card-title>
          {{ $capitalize($tc("model.documents_documents_title")) }}
          <v-spacer></v-spacer>
          <v-btn @click="getFiles" icon :loading="loading_files">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-btn @click="closeAllFolders" icon>
            <v-icon>mdi-folder</v-icon>
          </v-btn>
          <v-btn @click="openAllFolders" icon>
            <v-icon>mdi-folder-open</v-icon>
          </v-btn>
          <v-btn @click="openFilesDialog" color="primary">
            <v-icon size="24" left>mdi-paperclip</v-icon>{{ $capitalize($tc("model.documents_upload_button")) }}
          </v-btn>
        </v-card-title>
        <v-card-subtitle v-if="selected_files.length > 0">
          {{ selected_files.length }} {{ $capitalize($tc("model.documents_selected_files")) }}
          <v-btn small text color="primary">
            <v-icon class="mr-1" small>mdi-upload-multiple</v-icon>{{ $capitalize($tc("model.documents_send_files")) }}
          </v-btn>
        </v-card-subtitle>
        <div
          v-for="folder in folders"
          :key="folder.id"
          :class="{ 'dragging': dragging_over_folder === folder.id }"
        >
          <drop drop-effect="move" @dragenter="dragging_over_folder = folder.id" @drop="handleDrop">
            <v-list-item @click="folder.open = !folder.open">
              <v-list-item-icon>
                <v-icon right v-text="folder.open ? 'mdi-folder-open-outline' : 'mdi-folder-outline'"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  :class="{'primary--text': folder.open === true}"
                >{{folder.description}}</v-list-item-title>
                <v-list-item-subtitle>{{getFilesInFolder(folder.id).length}} {{ $capitalize($tc("model.documents_files_title")) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset></v-divider>
            <v-row no-gutters style="margin-left: 70px" v-show="folder.open">
              <v-col
                cols="12"
                sm="6"
                md="4"
                lg="3"
                v-for="file in getFilesInFolder(folder.id)"
                :key="file.id"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <drag
                      @dragstart="handleDragStart"
                      @dragend="handleDragEnd"
                      effect-allowed="move"
                      :transfer-data="{ file: file }"
                      :image-x-offset="65"
                      :image-y-offset="105"
                    >
                      <template slot="image">
                        <v-card>
                          <v-icon
                            size="100"
                            v-text="getFilesIcon(file)"
                            :color="getFilesIconColor(getFilesIcon(file))"
                          ></v-icon>
                        </v-card>
                      </template>
                      <v-card
                        flat
                        @click="open_file_preview(file)"
                        v-on="on"
                        v-bind="attrs"
                        :disabled="dragging"
                        :loading="file_loading === file.id"
                      >
                        <v-row no-gutters>
                          <v-col cols="2">
                            <v-img class="white--text align-center text-center" height="80px">
                              <v-icon
                                size="35"
                                v-text="getFilesIcon(file)"
                                :color="getFilesIconColor(getFilesIcon(file))"
                              ></v-icon>
                            </v-img>
                          </v-col>
                          <v-col class="text-left align-center my-auto text-truncate">
                            <v-card-subtitle>{{file.name}}</v-card-subtitle>
                          </v-col>
                        </v-row>
                      </v-card>
                    </drag>
                  </template>
                  <span>{{ file.name }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </drop>
        </div>
        <div :class="{ 'dragging': dragging_over_folder === null }">
          <drop drop-effect="move" @dragenter="dragging_over_folder = null" @drop="handleDrop">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ $capitalize($tc("model.documents_not_archived")) }}</v-list-item-title>
                <v-list-item-subtitle>{{files_without_folder.length}} {{ $capitalize($tc("model.documents_files_title")) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider inset></v-divider>
            <v-row no-gutters style="margin-left: 20px">
              <v-col
                cols="12"
                sm="6"
                md="4"
                lg="3"
                v-for="file in files_without_folder"
                :key="file.id"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <drag
                      @dragstart="handleDragStart"
                      @dragend="handleDragEnd"
                      effect-allowed="move"
                      :transfer-data="{ file: file }"
                      :image-x-offset="65"
                      :image-y-offset="105"
                    >
                      <template slot="image">
                        <v-card>
                          <v-icon
                            size="100"
                            v-text="getFilesIcon(file)"
                            :color="getFilesIconColor(getFilesIcon(file))"
                          ></v-icon>
                        </v-card>
                      </template>
                      <v-card
                        flat
                        @click="open_file_preview(file)"
                        v-on="on"
                        v-bind="attrs"
                        :disabled="dragging"
                        :loading="file_loading === file.id"
                      >
                        <v-row no-gutters>
                          <v-col cols="2">
                            <v-img class="white--text align-center text-center" height="80px">
                              <v-icon
                                size="35"
                                v-text="getFilesIcon(file)"
                                :color="getFilesIconColor(getFilesIcon(file))"
                              ></v-icon>
                            </v-img>
                          </v-col>
                          <v-col class="text-left align-center my-auto text-truncate">
                            <v-card-subtitle>{{file.name}}</v-card-subtitle>
                          </v-col>
                        </v-row>
                      </v-card>
                    </drag>
                  </template>
                  <span>{{ file.name }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </drop>
        </div>
      </v-card>
      <v-dialog v-model="file_preview" max-width="700px" overlay-opacity=".9">
        <v-card dark>
          <v-card-title>
            <v-icon size="23" left>{{getFilesIcon(file)}}</v-icon>
            {{ file.name }}
            <v-spacer />
            <v-btn @click="downloadFile(file)" icon>
              <v-icon>mdi-download</v-icon>
            </v-btn>
            <v-btn @click="handleEditFile(file)" icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn @click="confirm_file_deletion=true" icon>
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-btn @click="file_preview = false" icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-img contain max-height="600" v-if="isFileImage(file)" :src="getFilePublicUrl(file)"></v-img>
          <iframe
            v-else
            :src="getFilePublicUrl(file)"
            frameborder="0"
            width="100%"
            height="500px"
            style="background-color: white"
          ></iframe>
        </v-card>
      </v-dialog>
      <v-dialog v-model="change_file_name" max-width="400" persistent>
        <v-form @submit.prevent="changeFileName(file)">
          <v-card dark>
            <v-card-actions></v-card-actions>
            <v-card-text>
              <v-text-field autofocus label="Nome do arquivo" v-model="file_name"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="change_file_name = false">{{ $capitalize($tc("model.documents_cancel_button")) }}</v-btn>
              <v-btn type="submit" :loading="loading_change_file_name" color="primary">{{ $capitalize($tc("model.documents_save_button")) }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>

      <confirm-action-dialog
        :confirm_action="confirm_file_deletion"
        @change="confirm_file_deletion=$event"
        @action="deleteFile(file.id)"
        :message="
          $capitalize($tc('model.documents_file_remove_message'))
        "
      ></confirm-action-dialog>
    </v-col>
  </v-row>
</template>

<script>
import ConfirmActionDialog from "../ConfirmActionDialog";

export default {
  name: "files-tab",
  components: { ConfirmActionDialog },
  data: () => ({
    folders: [],
    files: [],
    file_preview: false,
    file: {},
    dragging_over_folder: 0,
    dragging: false,
    file_loading: null,
    change_file_name: false,
    file_name: "",
    loading_change_file_name: false,
    loading_files: false,
    confirm_file_deletion: false,
    deleting_file: null,
    show_select: null,
    selected_files: [],
  }),
  methods: {
    async deleteFile(file_id) {
      this.deleting_file = file_id;
      try {
        await this.$http.delete("/attachments/" + file_id);
        this.$store.commit("sendMessage", {
          text: "Arquivo excluído",
        });
        this.files = this.files.filter((file) => file.id !== file_id);
        this.file = {};
        this.confirm_file_deletion = false;
        this.file_preview = false;
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: error.response.data.message,
          color: "red",
        });
      } finally {
        this.deleting_file = null;
      }
    },
    async changeFileName(file) {
      this.loading_change_file_name = true;
      try {
        const response = await this.$http.put("/attachments/" + file.id, {
          name: this.file_name,
        });

        this.files = this.files.map((file_for_change) => {
          return file_for_change.id === file.id
            ? { ...response.data }
            : file_for_change;
        });
        this.file = { ...response.data };
        this.change_file_name = false;
      } catch (error) {
        this.$store.commit("sendMessage", {
          text: "Falha ao alterar nome",
          color: "red",
        });
      } finally {
        this.loading_change_file_name = false;
      }
    },
    handleEditFile(file) {
      this.file_name = file.name;
      this.change_file_name = true;
    },
    openFilesDialog() {
      this.$refs.file.click();
    },
    handleUploadFiles($event) {
      $event.target.files.forEach((file) => {
        this.loading_files = true;
        this.addFile(file)
          .then((response) => {
            this.files.push({ ...response.data });
          })
          .catch(error => {
            this.$store.commit('sendMessage', {
              text: error.response.data.message,
              color: 'red'
            })
          })
          .finally(() => {
            this.loading_files = false;
          });
      });

      this.$refs.file.value = "";
    },
    closeAllFolders() {
      this.folders = this.folders.map((folder) => {
        return { ...folder, open: false };
      });
    },
    openAllFolders() {
      this.folders = this.folders.map((folder) => {
        return { ...folder, open: true };
      });
    },
    async handleDrop(data, event) {
      if (data) {
        if (data.file.category_id !== this.dragging_over_folder) {
          this.file_loading = data.file.id;
          try {
            const response = await this.$http.put(
              "/attachments/" + data.file.id,
              {
                category_id: this.dragging_over_folder,
              }
            );

            this.files = this.files.map((file) => {
              if (file.id === data.file.id) {
                return { ...file, category_id: response.data.category_id };
              }

              return file;
            });
          } catch (error) {
            this.$store.commit("sendMessage", {
              text: "Não foi possível mover o arquivo",
              color: "red",
            });
          } finally {
            this.file_loading = null;
          }
        }
      }

      event.dataTransfer.files.forEach((file) => {
        this.loading_files = true;
        this.addFile(file, this.dragging_over_folder)
          .then((response) => {
            this.files.push({ ...response.data });
          })
          .finally(() => {
            this.loading_files = false;
          });
      });

      this.dragging_over_folder = 0;
      this.dragging = false;
    },
    addFile(file, category_id = null, description = "teste") {
      let data = new FormData();
      data.append("attachment", file);
      if (category_id !== null) data.append("category_id", category_id);
      data.append("description", description);

      return this.$http.post(
        "/leads/" + this.$route.params["lead_number"] + "/attachments",
        data
      );
    },
    handleDragStart() {
      this.dragging = true;
      // this.closeAllFolders();
    },
    handleDragEnd() {
      this.dragging = false;
      this.dragging_over_folder = 0;
      // this.openAllFolders();
    },
    isFileImage(file) {
      const image_extensions = ["jpg", "jpeg", "png", "gif"];

      let is_image = false;

      image_extensions.forEach((extension) => {
        if (extension === file.extension) {
          is_image = true;
        }
      });

      return is_image;
    },
    async downloadFile(file) {
      window.open(file.public_url);
    },
    getFilePublicUrl(file) {
      switch (file.extension) {
        case "xlsx":
        case "pptx":
        case "docx":
          return this.microsoft_preview(file.public_url);
        default:
          return file.public_url;
      }
    },
    microsoft_preview(public_url) {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${public_url}`;
    },
    open_file_preview(file) {
      this.file_preview = true;
      this.file = file;
    },
    async getFolders() {
      const response = await this.$http.get("/attachments_categories");
      this.folders = response.data.map((folder) => {
        return {
          ...folder,
          open: true,
        };
      });
    },
    async getFiles(silent = false) {
      this.loading_files = true;
      if (silent == false) {
        this.files = [];
      }
      const response = await this.$http.get(
        "/leads/" + this.$route.params["lead_number"] + "/attachments"
      );
      this.files = response.data;
      this.loading_files = false;
    },
    getFilesInFolder(folder_id) {
      return this.files.filter((file) => {
        return file.category_id == folder_id;
      });
    },
    getFilesIcon(file) {
      let extension = file.extension;
      if (extension) {
        extension = extension.replace(".", "");
      }
      switch (extension) {
        case "jpg":
        case "jpeg":
        case "png":
          return "mdi-file-image";
        case "pdf":
          return "mdi-file-pdf";
        case "doc":
        case "docm":
        case "dot":
        case "dotm":
        case "docx":
        case "dotx":
          return "mdi-file-word";
        case "pptx":
          return "mdi-file-powerpoint";
        case "xlsx":
          return "mdi-file-excel";
        case "zip":
        case "rar":
          return "mdi-zip-box";
        case "txt":
          return "mdi-file-document";
        default:
          return "mdi-file";
      }
    },
    getFilesIconColor(file_icon) {
      switch (file_icon) {
        case "mdi-file-pdf":
          return "#e5625b";
        case "mdi-file-word":
          return "#285495";
        case "mdi-file-excel":
          return "#1F7045";
        case "mdi-file-powerpoint":
          return "#CA4324";
        case "mdi-zip-box":
          return "#6186B2";
        default:
          return "";
      }
    },
  },
  computed: {
    files_without_folder: function () {
      return this.files.filter((file) => {
        return file.category_id == null;
      });
    },
  },
  created() {
    this.getFolders();
    this.getFiles();
  },
};
</script>